import { CanvasObject } from 'components/canvas/CanvasObject';

export default class DecimalPointer extends CanvasObject {
  constructor(id, locked, x, y, label) {
    super('DecimalPointer.' + id, locked, x, y, 10);
    this.label = label;
  }

  draw(ctx) {
    const { x, y, rad, locked, label } = this;

    ctx.beginPath();
    if (locked) {
      // Cross
      ctx.moveTo(x - rad, y - rad);
      ctx.lineTo(x + rad, y + rad);
      ctx.moveTo(x + rad, y - rad);
      ctx.lineTo(x - rad, y + rad);
    } else {
      // Circle
      ctx.arc(x, y, rad, 0, Math.PI * 2, false);
    }
   
    // Draw black stroke & white/yellow path
    ctx.lineWidth = 3;
    ctx.strokeStyle = 'black';
    ctx.stroke();
    ctx.lineWidth = 2;
    ctx.strokeStyle = this.active ? 'yellow' : 'white';
    ctx.stroke();

    // Target dot
    if (!locked) {
      //ctx.globalCompositeOperation = 'difference';
      ctx.fillStyle = 'white';
      ctx.beginPath();
      ctx.arc(x, y, 1.5, 0, Math.PI * 2, false);
      ctx.fill();
    }

    // Label
    if (label) {
      let color = undefined;
      switch (label) {
        case 0.1:
          color = "#F3F3F3";
          break;
        case 0.01:
          color = "#DADADA";
          break;
        case 0.001:
          color = "#B4B4B4";
          break;
        case 0.0001:
          color = "#8F8F8F";
          break;
        default:
          color = 'white';
          break;
      }
      ctx.strokeStyle = this.active ? 'yellow' : color;
      ctx.fillStyle = ctx.strokeStyle;
      ctx.strokeStyle = 'black';
      ctx.textBaseline = 'top';
      ctx.textAlign = 'center';
      ctx.font = "18px Arial";
      ctx.strokeText(label, x, y + rad + 2);
      ctx.fillText(label, x, y + rad + 2);
    }
  }

  export() {
    return {
      x: Math.round(this.x),
      y: Math.round(this.y)
    }
  }
}



// WEBPACK FOOTER //
// ./client/components/canvas/DecimalPointer.js